import {
  DataTableColumnDateProps,
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableServerQuery,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '@/components/data-table-builder/data-table.types';

interface getCurrencyHistoryDataTableStructureProps {
  serverQuery?: DataTableServerQuery;
}

export const getCurrencyHistoryDataTableStructure = ({ serverQuery }: getCurrencyHistoryDataTableStructureProps): DynamicDataTable => {
  const idColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.currency.table.id',
    accessorKey: 'id',
    variant: DataTableColumnVariant.TEXT,
  };

  const currencyIdColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.currency.table.id',
    accessorKey: 'deviseId',
    variant: DataTableColumnVariant.TEXT,
  };

  const codeColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.currency.table.code',
    accessorKey: 'code',
    variant: DataTableColumnVariant.TEXT,
  };

  const descriptionColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.currency.table.description',
    accessorKey: 'description',
    variant: DataTableColumnVariant.TEXT,
  };

  const tauxColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.currency.table.taux',
    accessorKey: 'taux',
    variant: DataTableColumnVariant.TEXT,
  };

  const startDateColumn: DynamicDataTableColumn<DataTableColumnDateProps> = {
    label: 'settings.currency.table.startDate',
    accessorKey: 'dateDebut',
    variant: DataTableColumnVariant.DATE,
    props: {
      format: 'dd/MM/yyyy HH:mm:ss',
    },
  };

  const endDateColumn: DynamicDataTableColumn<DataTableColumnDateProps> = {
    label: 'settings.currency.table.endDate',
    accessorKey: 'dateFin',
    variant: DataTableColumnVariant.DATE,
    props: {
      format: 'dd/MM/yyyy HH:mm:ss',
    },
  };

  const actionColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.currency.table.action',
    accessorKey: 'action',
    variant: DataTableColumnVariant.TEXT,
  };

  const changedByColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.currency.table.changedBy',
    accessorKey: 'changedBy',
    variant: DataTableColumnVariant.TEXT,
  };
  return {
    singular: 'settings.currency.history.table.singular',
    plural: 'settings.currency.history.table.plural',
    columns: [idColumn, currencyIdColumn, codeColumn, descriptionColumn, tauxColumn, startDateColumn, endDateColumn, actionColumn, changedByColumn],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    serverQuery,
    enableServerActions: true,
    searchableFields: ['id', 'deviseId', 'code', 'description', 'taux', 'dateDebut', 'dateFin', 'action', 'changedBy'],
  };
};
